/**
 * Paginación por cursor.
 *
 * Todos los listados de entrenamiento del contrato devuelven la misma forma,
 * `{ items, nextCursor }`, y se avanzan reenviando `nextCursor` como `cursor`
 * hasta que llega a `null`. Aquí vive la lógica común para no repetirla en cada
 * namespace.
 */
/**
 * Recorre un listado paginado elemento a elemento, pidiendo cada página solo
 * cuando hace falta.
 *
 * El `cursor` de `query` (si lo hay) marca el punto de partida; a partir de ahí
 * se sigue el `nextCursor` de cada respuesta hasta que vale `null`. El resto de
 * filtros se reenvían intactos en todas las páginas.
 *
 * @example
 * for await (const exercise of paginate(fetchPage, { q: 'press', limit: 100 })) {
 *   console.log(exercise.nameEs);
 * }
 */
export async function* paginate(fetchPage, query) {
    const base = (query ?? {});
    let cursor = base.cursor;
    for (;;) {
        const page = await fetchPage((cursor === undefined ? { ...base } : { ...base, cursor }));
        for (const item of page.items)
            yield item;
        // Un `nextCursor` no nulo con la página vacía significaría seguir pidiendo:
        // el contrato lo permite, pero conviene cortar si el servidor devuelve el
        // mismo cursor, para no quedarse en bucle.
        if (page.nextCursor === null || page.nextCursor === cursor)
            return;
        cursor = page.nextCursor;
    }
}
/**
 * Vuelca un iterador asíncrono en un array. Atajo para cuando el listado cabe
 * en memoria sin problema.
 *
 * @example
 * const todas = await collectAll(api.routines.iterate({ includeArchived: true }));
 */
export async function collectAll(iterable) {
    const all = [];
    for await (const item of iterable)
        all.push(item);
    return all;
}
//# sourceMappingURL=pagination.js.map